import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPencil,
  faPlus,
} from '@fortawesome/pro-light-svg-icons'

import { Button } from '@domain-group/suit-theme'

import useRedirectUrlWithCacheKey from '@hooks/useRedirectUrlWithCacheKey'
import { generateUrls } from '@hooks/useArtwork'
import { UseCampaignQuoteItemPayload } from '@hooks/useCampaignQuoteItem'
import { ArtworkModel, CampaignQuoteItemModel } from '@domain-group/realhub-backend-api-types'

interface ArtworkButtonProps {
  campaignQuoteItemPayload: UseCampaignQuoteItemPayload,
  modalHandler: (campaignQuoteItemPayload: CampaignQuoteItemModel) => void
}

const ArtworkButton = (props: ArtworkButtonProps) => {
  const {
    campaignQuoteItemPayload: {
      artwork,
      campaignQuoteItem,
      canCreateArtwork,
      requiredItems,
    },
    modalHandler
  } = props

  const { redirectUrl } = useRedirectUrlWithCacheKey([campaignQuoteItem.campaign_quote_id])

  if (!requiredItems.artwork || !canCreateArtwork){
    return null
  }

  // @ts-expect-error TS2339
  const urls = generateUrls({ campaign_quote_item_id: campaignQuoteItem.id, id: artwork.id }, {
    includeRedirect: true,
    redirectUrl,
  })
  //@ts-expect-error
  const hasArtwork = !!artwork?.id
  if (hasArtwork) {
    return (
      <Button
        // @ts-expect-error TS2322
        as="a"
        buttonStyle="secondaryUtility"
        href={urls.editArtworkUrl}
        icon={<FontAwesomeIcon icon={faPencil} />}
        size="medium"
      >
        Edit Artwork
      </Button>
    )
  }

  // 2. Create Artwork Mode (Renders a standard button with onClick)
  return (
    <Button
      buttonStyle="secondaryUtility"
      icon={<FontAwesomeIcon icon={faPlus} />}
      size="medium"
      onClick={() => modalHandler(campaignQuoteItem)}
    >
      Create Artwork
    </Button>
  )
}

export default ArtworkButton
